(() => {
  'use strict';

  const ROOT = '[data-pax-product]';
  const THUMB = '[data-pax-thumb]';
  const MAIN = '[data-pax-main-image]';

  const getRoot = (el) => el && el.closest ? el.closest(ROOT) : null;
  const getThumbs = (root) => Array.from(root.querySelectorAll(THUMB));

  const activateThumb = (thumb, options = {}) => {
    const root = getRoot(thumb);
    if (!root) return;

    const main = root.querySelector(MAIN) || root.querySelector('.pax-product-stage__image');
    const src = thumb.dataset.large || thumb.getAttribute('data-large');
    if (!main || !src) return;

    // Responsive source candidates can otherwise keep the old image visible.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.setAttribute('src', src);
    main.src = src;

    if (thumb.dataset.alt) main.alt = thumb.dataset.alt;

    getThumbs(root).forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    if (options.scroll !== false) {
      try {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      } catch (e) {}
    }
  };

  const cycleMainImage = (main) => {
    const root = getRoot(main);
    if (!root) return;

    const thumbs = getThumbs(root);
    if (thumbs.length < 2) return;

    let index = thumbs.findIndex((item) =>
      item.classList.contains('is-active') || item.getAttribute('aria-pressed') === 'true'
    );
    if (index < 0) index = 0;

    activateThumb(thumbs[(index + 1) % thumbs.length]);
  };

  const updateVariant = (select) => {
    const root = getRoot(select);
    if (!root) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    const available = option.dataset.available === 'true';
    const price = root.querySelector('[data-pax-price]');
    const compare = root.querySelector('[data-pax-compare]');
    const sku = root.querySelector('[data-pax-sku]');
    const summarySku = root.querySelector('[data-pax-summary-sku]');
    const availability = root.querySelector('[data-pax-availability]');
    const availabilityText = root.querySelector('[data-pax-availability-text]');
    const add = root.querySelector('[data-pax-add]');
    const addLabel = root.querySelector('[data-pax-add-label]');

    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (sku) sku.textContent = option.dataset.sku || '—';
    if (summarySku) summarySku.textContent = option.dataset.sku || '—';
    if (availability) availability.classList.toggle('is-out', !available);
    if (availabilityText) {
      availabilityText.textContent = available
        ? 'Tillgänglig för beställning'
        : 'Tillfälligt ej tillgänglig';
    }
    if (add) add.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Lägg i varukorgen' : 'Ej tillgänglig';

    const mediaId = option.dataset.mediaId;
    if (mediaId) {
      const thumb = getThumbs(root).find((item) => item.dataset.mediaId === mediaId);
      if (thumb) activateThumb(thumb, { scroll: false });
    }

    try {
      history.replaceState({}, '', window.location.pathname + '?variant=' + encodeURIComponent(option.value));
    } catch (e) {}
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest && event.target.closest(THUMB);
    if (thumb) {
      event.preventDefault();
      event.stopPropagation();
      activateThumb(thumb);
      return;
    }

    const main = event.target.closest && event.target.closest(MAIN);
    if (main) {
      event.preventDefault();
      cycleMainImage(main);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const thumb = event.target.closest && event.target.closest(THUMB);
    if (!thumb) return;

    event.preventDefault();
    activateThumb(thumb);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('[data-pax-variant-select]');
    if (select) updateVariant(select);
  });
})();
